var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"main-view",attrs:{"id":"inspire"}},[(_vm.ok)?[_c('default-app-bar'),_c('default-menu-left'),_c('default-settings'),_c('div',{staticClass:"px-6"},[_c('default-view')],1)]:_vm._e(),_c('overlay-loading')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }